<template>
  <BaseTable :name='name' :getDataAction='getDataAction' :tableColumns='tableColumns' @SizeChange='sizeChange' @StateChange='stateChange'></BaseTable>
</template>


<script>
import {
  GetPurchaseApplyReportViews
} from '@/api'
import BaseTable from './../baseTable.vue'

export default ({
  components: {
    BaseTable
  },
  data () {
    return {
      getDataAction: GetPurchaseApplyReportViews,
      tableColumns: [
        {
          no: 'createdTime',
          name: '日期',
          width: 100,
          type: 'date',
          dateFormatter: '{y}-{m}-{d}'
        },
        {
          no: 'no',
          name: '单号',
          width: 100,
          type: 'text',
        },
        {
          no: 'deptName',
          name: '科室',
          width: 100,
          type: 'text',
        },
        {
          no: 'productName',
          name: '产品名称',
          width: 100,
          type: 'text',
        },
        {
          no: 'specName',
          name: '规格型号',
          width: 100,
          type: 'text',
        },
        {
          no: 'manufacturerName',
          name: '生产厂家',
          width: 100,
          type: 'text',
        },
        {
          no: 'number',
          name: '请领数量',
          width: 80,
          type: 'text',
        },
        // {
        //   no: 'outStockNumber',
        //   name: '已完成数量',
        //   width: 100,
        //   type: 'text',
        // },
        {
          no: 'status',
          name: '完成情况',
          width: 80,
          type: 'progress',
          number: 'outStockNumber',
          totalNumber: 'number'
        },

      ],
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
  },
  methods: {

    sizeChange (a, b, c, d) {
      this.$emit('SizeChange', a, b, c, d)
    },
    stateChange (a, b) {
      this.$emit('StateChange', a, b)
    },
  },
  mounted () {
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
  },
  beforeDestroy () {
  },
})
</script>
<style scoped lang="scss">
</style>
